import { render } from "./InputProjectParams.vue?vue&type=template&id=3b5c3a34&lang=true"
import script from "./InputProjectParams.vue?vue&type=script&lang=js"
export * from "./InputProjectParams.vue?vue&type=script&lang=js"

import "./InputProjectParams.vue?vue&type=style&index=0&id=3b5c3a34&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__